import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logoConduto from '../../assets/img/logo-conduto.png';
import './Login.css';

const Login = ({ redirectTo = '/administrador/sugerencias' }) => {
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate(redirectTo, { replace: true });
    }
  }, [navigate, redirectTo]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch('https://api-sugerencias.conduto.com.ec/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: formData.username,
          password: formData.password
        }),
      });

      const data = await response.json();

      if (data.success) {
        const token = data.data.token;
        const usuario = data.data.usuario;

        console.log('💾 Guardando token:', token ? 'Token válido' : 'Token vacío');
        console.log('👤 Usuario:', usuario);

        localStorage.setItem('token', token);
        localStorage.setItem('usuario', JSON.stringify(usuario));

        // Verifica que se guardó
        setTimeout(() => {
          console.log('✅ Token en localStorage:', localStorage.getItem('token')?.substring(0, 20) + '...');
          navigate(redirectTo, { replace: true });
        }, 100);
      } else {
        setError(data.message || 'Error en el login');
      }
    } catch (error) {
      console.error('❌ Error:', error);
      setError('Error de conexión con el servidor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="login-page"
      style={{
        margin: 0,
        padding: 0,
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        minHeight: '100vh',
      }}
    >
      <div className="login-container">
        <div className="login-form">
          <div className="logo-section">
            <img src={logoConduto} alt="Logo Conduto" className="logo" />
          </div>

          <form onSubmit={handleSubmit}>
            <h2 style={{ color: '#004892' }}>Iniciar Sesión</h2>

            {error && <div className="alert alert-danger">{error}</div>}

            <div className="form-group">
              <label htmlFor="username">Usuario</label>
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
                disabled={loading}
                placeholder="Ingrese su usuario"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Contraseña</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                disabled={loading}
                placeholder="Ingrese su contraseña"
              />
            </div>

            <button type="submit" className="btn-login" disabled={loading}>
              {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;